import {
  GraphQLNonNull,
  GraphQLInputObjectType,
  GraphQLID,
  GraphQLString,
  GraphQLFieldConfig
} from 'graphql'
import {
  GenericMutationResponseType,
  GenericMutationResponse
} from '../types/generic-mutation-response'
import { Context } from '../shared'

interface EnableVulnerabilityPolicyMutationArgs {
  readonly input: {
    readonly policyID: string
    readonly organizationID: string
  }
}

const enableVulnerabilityPolicyMutationArgs = {
  input: {
    type: new GraphQLInputObjectType({
      name: 'EnableVulnerabilityPolicyMutationArgs',
      fields: () => ({
        organizationID: {
          type: new GraphQLNonNull(GraphQLID)
        },
        policyID: {
          type: new GraphQLNonNull(GraphQLString)
        }
      })
    })
  }
}

export const enableVulnerabilityPolicy: GraphQLFieldConfig<
  undefined,
  Context,
  EnableVulnerabilityPolicyMutationArgs
> = {
  description: 'Enable or disable a vulnerability policy',
  type: new GraphQLNonNull(GenericMutationResponseType),
  args: enableVulnerabilityPolicyMutationArgs,
  async resolve(
    _source,
    args: EnableVulnerabilityPolicyMutationArgs,
    context: Context
  ): Promise<GenericMutationResponse> {
    const {
      input: { organizationID, policyID }
    } = args

    await context.connector.put(
      `${organizationID}/policy/remediation/${policyID}/status`
    )

    return {
      _placeholder: true
    }
  }
}
